export default {
  PRODUCT: 'PRODUCT',
  SELECTION: 'SELECTION',
  BAR: 'BAR',
  PLACEHOLDER: 'PLACEHOLDER',
};
